// extracted by mini-css-extract-plugin
module.exports = {"questions":"style_questions__2jSsP","item":"style_item__18l0H","answerWrapper":"style_answerWrapper__1b7kK","offImg":"style_offImg__1n08D","showAnswer":"style_showAnswer__J5uko"};